import axios from 'axios';

export const canLinkAccounts = async (email: string) =>
  axios.get('user/link', { params: { email } });
